import { Link } from "react-router-dom";
import { DfeLogo } from "@/components/Nav";
import { useLang } from "@/lib/i18n";

const LINKS = [
  { to: "/about", zh: "关于", en: "ABOUT" },
  { to: "/works", zh: "作品", en: "WORKS" },
  { to: "/calendar", zh: "演出日历", en: "CALENDAR" },
  { to: "/services", zh: "服务", en: "SERVICES" },
  { to: "/team", zh: "团队", en: "TEAM" },
  { to: "/contact", zh: "联络", en: "CONTACT" },
];

export default function Footer() {
  const { lang } = useLang();
  return (
    <footer className="bg-[#050505] border-t border-white/10" data-testid="footer">
      <div className="max-w-[1800px] mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="flex flex-col md:flex-row justify-between gap-10">
          <div>
            <div className="flex items-center">
              <DfeLogo size={72} />
            </div>
            <p className="font-mono2 text-[10px] text-[#52525b] tracking-[0.3em] mt-6">WHERE MUSIC MEETS DREAMS</p>
          </div>
          <nav className="flex flex-wrap gap-x-10 gap-y-4">
            {LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="font-zh text-sm text-[#a1a1aa] hover:text-[#ffde00] transition-colors"
              >
                {lang === "zh" ? l.zh : l.en}
              </Link>
            ))}
            <a href="/admin" className="font-mono2 text-xs text-[#27272a] hover:text-[#ffde00] transition-colors" data-testid="footer-admin-link">
              ADMIN
            </a>
          </nav>
        </div>
        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row justify-between gap-2">
          <p className="font-mono2 text-[10px] text-[#52525b] tracking-[0.2em]">© 2009–2025 DREAM FACTORY ENTERTAINMENT</p>
          <p className="font-mono2 text-[10px] text-[#52525b] tracking-[0.2em]">KUALA LUMPUR · MALAYSIA</p>
        </div>
      </div>
    </footer>
  );
}
